import { Link, useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import { useAppDispatch } from "../../redux/store"
import { logoutUser } from "../../redux/slices/auth/authSlice"
import { IconBalance, IconDownload } from "../utils/Icons/CustomIcons"
import { useAppSelector } from "../../redux/store"
import { Button } from "react-bootstrap"
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary

const HeaderBurger = ({ isOpenMenu, setIsOpenMenu }: any) => {
  const { isAuth, loginType } = useAppSelector((state) => state.auth)

  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const onClick = () => {
    setIsOpenMenu(!isOpenMenu)
  }

  return (
    <Navbar
      expand="lg"
      className="header-toggle d-lg-none"
      expanded={isOpenMenu}
      onToggle={onClick}
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav">
        <div className="burger">
          <span className="burger__line"></span>
          <span className="burger__line"></span>
          <span className="burger__line"></span>
        </div>
      </Navbar.Toggle>

      <Navbar.Collapse id="basic-navbar-nav">
        <div className="container">
          <Nav className="header-nav">
            <Link to="/profile" className="header-nav__link" onClick={onClick}>
              <span className="header-nav__text">
                {" "}
                {t("header.nav.profile")}
              </span>
            </Link>
            <Link to="/purchase" className="header-nav__link" onClick={onClick}>
              <span className="header-nav__text"> {t("header.nav.topUp")}</span>
            </Link>
            <span
              className="header-nav__link"
              onClick={() => {
                // Dispatch logoutUser action first
                dispatch(logoutUser())
                // Navigate to the /welcome route afterward
                navigate("/welcome")
              }}
            >
              <span className="header-nav__text">{t("buttons.exit")}</span>
            </span>
          </Nav>

          <div className="header-toggle__balance">
            <a
              href="https://apps.apple.com/sa/app/invite-smart/id1485707176"
              target="_blank"
              className="btn btn-simple"
            >
              <IconDownload />
              {t("buttons.downloadApp")}
            </a>
          </div>
        </div>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default HeaderBurger
